import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import InputField from "../../InputField";
import exportImage from "../../../asset/Images";
import { colors } from "@mui/material";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { type } from "@testing-library/user-event/dist/type";
import Popup from "../../popupmodal/Popup";

export default function QuotationCom() {
  const storedBranchArray =
    JSON.parse(sessionStorage.getItem("branchNames")) || [];
  const [selectBranch, setSelectedBranch] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState();

  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // GET API START
  const quotationData = async () => {
    return await axios.get(
      `${process.env.REACT_APP_HOST}/quotation/${selectBranch}/all`
    );
  };

  const { data, isLoading, isError, refetch } = useQuery(
    ["quotationData", selectBranch],
    quotationData,
    {
      enabled: !!selectBranch,
      refetchOnWindowFocus: false,
    }
  );
  // GET API END

  let details = data && data?.data;

  const filteredDetails = searchTerm
    ? details?.filter((item) => {
        const nameMatch = item?.customerName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        const statusMatch = item?.siteAddress
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        return nameMatch || statusMatch;
      })
    : details;

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows =
    filteredDetails && filteredDetails?.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(
    filteredDetails && filteredDetails?.length / rowsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Download Excel
  const downloadExcel = () => {
    // Define headers
    const headers = [
      "QUOTATION NO",
      "CUSTOMER NAME",
      "SITE NAME",
      "MOBILE NUMBER",
      "BRANCH",
      "STATUS",
    ];

    // Map data to match the headers order
    const formattedData =
      currentRows &&
      currentRows?.map((item, index) => ({
        "QUOTATION NO": index + 1,
        "CUSTOMER NAME": item?.customer_name || "",
        "SITE NAME": item?.site_address || "",
        "MOBILE NUMBER": item?.mobile_number || "",
        BRANCH: item?.branch || "",
        STATUS: item?.status || "",
      }));

    // Create a new workbook and a worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, "View Quotation.xlsx");
  };

  // DELETE API

  const { mutate, isLoading: deleteLoading } = useMutation(
    async (deleteId) => {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_HOST}/quotation/${selectBranch}/${deleteId}`
        );
        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error; // To trigger onError
      }
    },
    {
      onSuccess: () => {
        refetch(); // Refresh data after successful deletion
        setPopupType({
          type: "delete success",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to delete invoice. Please try again.");
      },
    }
  );

  const handleDelete = () => {
    if (deleteId) {
      mutate(deleteId);
    } else {
      alert("No invoice selected for deletion.");
    }
  };

  // DELETE API END

  let Interested = 0;
  let notinterested = 0;
  let overall = 0;

  currentRows &&
    currentRows.forEach((data, i) => {
      if (data?.interest === "Interested") {
        Interested += 1;
      } else if (data?.interest === "Not Interested") {
        notinterested += 1;
      }
    });

  overall = currentRows ? currentRows?.length : 0;

  const overAllReportDetails = [
    {
      name: "OVERALL",
      value: `${overall || 0}`,
      colorCode: "rgba(0, 184, 238, 0.3)",
      textColorCode: "rgba(0, 184, 238, 1)",
    },
    {
      name: "Converted",
      value: "0",
      colorCode: "rgba(1, 156, 80, 0.3)",
      textColorCode: "rgba(1, 156, 80, 1)",
    },
    {
      name: "Interested",
      value: `${Interested || 0}`,
      colorCode: "rgba(240, 145, 19, 0.3)",
      textColorCode: "rgba(240, 145, 19, 1)",
    },
    {
      name: "Not Interested",
      value: `${notinterested || 0}`,
      colorCode: "rgba(237, 52, 54, 0.3)",
      textColorCode: "rgba(237, 52, 54, 1)",
    },
  ];
  useEffect(() => {
    const savedBranch = sessionStorage.getItem("selectedBranch");
    if (savedBranch) {
      setValue("branchSelect", savedBranch);
      setSelectedBranch(savedBranch);
    }
  }, []);

  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">Quotation </div>
            <div
              className="header_Btn_container"
              onClick={() => {
                navigate("/quatation/quotationAdd");
              }}
            >
              Add Quotation
            </div>
          </header>
          <section className="viewPageSectionContainer">
            <div className="reportMainContainer">
              {overAllReportDetails?.map((item, index) => {
                return (
                  <div className="overall-card">
                    <div className="overall-text">
                      <div
                        className="overall-label"
                        style={{ color: item.textColorCode }}
                      >
                        {item.name}
                      </div>
                      <div
                        className="overall-value"
                        style={{ color: item.textColorCode }}
                      >
                        {item.value}
                      </div>
                    </div>
                    <div
                      className="bg-shape1"
                      style={{ background: item.colorCode }}
                    ></div>
                    <div
                      className="bg-shape2"
                      style={{ background: item.colorCode }}
                    ></div>
                  </div>
                );
              })}
            </div>

            <div className="searchSelectMainContainer ">
              <div className="quotationInputSearch">
                <div className="searchInput">
                  <label className="searchInputLabel">Search</label>

                  <input
                    type="search"
                    className="searchInputCss"
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                    }}
                    placeholder="search by customer, site"
                  />
                </div>
              </div>
              <div className="quotationSelectSearch">
                <div className="selectContainer">
                  {/* <div className="searchInput">
                    <Controller
                      control={control}
                      name="selectDate"
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <InputField
                          type="date"
                          searchSelectCss="searchSelectCss"
                        />
                      )}
                    />
                  </div> */}
                </div>
                <div className="selectContainer">
                  <div className="searchInput">
                    <Controller
                      name="branchSelect"
                      control={control}
                      rules={{ required: "Branch selection is required" }}
                      render={({ field }) => (
                        <select
                          {...field}
                          className="searchSelectCss"
                          onChange={(e) => {
                            field.onChange(e); // Update form state
                            setSelectedBranch(e.target.value); // Update local state
                            sessionStorage.setItem(
                              "selectedBranch",
                              e.target.value
                            );
                          }}
                          value={field.value || ""}
                        >
                          <option value="">-Select Branch-</option>
                          {storedBranchArray?.map((branch, index) => (
                            <option key={index} value={branch}>
                              {branch}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                    {errors.branchSelect && (
                      <p style={{ color: "red" }}>
                        {errors.branchSelect.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="header_Btn_container" onClick={downloadExcel}>
                  Download
                </div>
              </div>
            </div>

            <div className="tableMainContainer">
              <table className="tableMain">
                <thead>
                  <tr className="tableHeadRow">
                    <td className="tableHeaderTxt ">Quotation No</td>
                    <td className="tableHeaderTxt ">Customer Name</td>
                    <td className="tableHeaderTxt ">Site Name</td>
                    <td className="tableHeaderTxt ">Mobile No</td>
                    <td
                      className="tableHeaderTxt "
                      style={{
                        width: "260px",
                      }}
                    >
                      Branch
                    </td>
                    <td className="tableHeaderTxt ">Status</td>
                    <td
                      className="tableHeaderTxt "
                      style={{
                        width: "260px",
                      }}
                    >
                      Action
                    </td>
                  </tr>
                </thead>
                <tbody className="tableBody">
                  {isLoading ? (
                    <>
                      {/* <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <div className="loader"></div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr> */}
                      <h5>L O A D I N G . . .</h5>
                    </>
                  ) : currentRows?.length > 0 ? (
                    currentRows &&
                    currentRows?.map((item, index) => {
                      return (
                        <tr>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.quotationNo || "-"}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.customerName || "-"}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.siteAddress || "-"}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.mobileNumber || "-"}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.branch || "-"}
                          </td>
                          <td
                            style={{
                              color:
                                item?.interest === "Interested"
                                  ? "#FFA500"
                                  : "red",
                              backgroundColor:
                                index % 2 === 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.interest || "-"}
                          </td>
                          <td
                            className="tableDataTxt "
                            style={{
                              width: "260px",
                              height: "100%",
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                          >
                            <div className="d-flex gap-1 align-items-center">
                              <div
                                className="actionBtn"
                                onClick={() => {
                                  navigate("/quatation/quotationAdd", {
                                    state: item,
                                  });
                                }}
                                style={{ cursor: "pointer" }}
                                title="Edit Icon"
                              >
                                <img
                                  className="mb-1"
                                  src={exportImage?.editIcon}
                                  alt="editIcon"
                                />
                              </div>
                              <div
                                className="actionBtn"
                                onClick={() => {
                                  setIsModalOpen(true);
                                  setPopupType({
                                    ...popupType,
                                    type: "confirm delete",
                                  });
                                  setDeleteId(item?.id);
                                }}
                                title="Delete Icon"
                              >
                                <img
                                  className="mb-1"
                                  src={exportImage?.deleteIcon}
                                  alt="deleteIcon"
                                />
                              </div>
                              <div
                                className="actionBtn"
                                onClick={() => {
                                  localStorage.setItem(
                                    "duplicateData",
                                    JSON.stringify(item)
                                  );
                                  navigate("/quatation/quotationAdd");
                                }}
                                title="Duplicate Entry"
                              >
                                <img
                                  className="mb-1"
                                  src={exportImage?.duplicateIcon}
                                  alt="duplicateIcon"
                                />
                              </div>
                              <div
                                className="actionBtn"
                                onClick={() => {
                                  navigate("/quatation/quotationInvoice", {
                                    state: item,
                                  });
                                }}
                                title="Download Icon"
                              >
                                <img
                                  className="mb-1"
                                  src={exportImage?.downloadIcon}
                                  alt="downloadIcon"
                                />
                              </div>
                              <div
                                className="actionBtn"
                                onClick={() => {
                                  navigate("/project/projectAdd");
                                }}
                                title="convert to project"
                              >
                                <img
                                  className="mb-1 rotate-right"
                                  src={exportImage?.downloadIcon}
                                  alt="downloadIcon"
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <p className="noDataFoundTxt">No Data Found</p>
                  )}
                </tbody>
              </table>
            </div>
          </section>
          <nav aria-label="Page navigation example" className="mt-2">
            <ul className="pagination justify-content-center">
              {/* Previous Button */}
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
              </li>

              {/* Page Numbers */}
              {Array?.from({ length: totalPages })?.map((_, index) => {
                const pageNumber = index + 1;
                const isActive = currentPage === pageNumber;

                return (
                  <li
                    key={pageNumber}
                    className={`page-item ${isActive ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                );
              })}

              {/* Next Button */}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &raquo;
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <Popup
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        handleDelete={handleDelete}
        deleteLoading={deleteLoading}
        message="Are you sure you want to delete the Quotation details?"
      />
      <Popup
        isOpen={deletePopup}
        closePopup={() => setDeletePopup(false)}
        setPopupType={setPopupType}
        popupType={popupType}
        deleteLoading={deleteLoading}
      />
    </>
  );
}
